import type { FileImportSummaryResponse } from 'api/__GENERATED';

// FileImportSummaryResponse is the array type after the OpenAPI regen;
// a single DTO is the element type.
type FileImportSummaryDto = FileImportSummaryResponse[number];

// Maps a single FileImportSummaryResponse DTO to Data.File. Field names
// mirror the legacy api_old/Actual transformer, including the existing
// typo `proccessed` on Data.File that downstream code depends on.
function toFile(dto: FileImportSummaryDto): Data.File {
  const {
    fileId,
    friendlyFileName,
    processedRecordsCount,
    totalRecordsCount,
    skippedRecordsDetails: { errorRecordsCount, noMatchRecordsCount },
    importedAt,
    isProcessed,
  } = dto;

  const file: Data.File = {
    id: fileId,
    name: friendlyFileName,
    errors: errorRecordsCount,
    isProcessed,
    proccessed: processedRecordsCount,
    importedAt,
    total: totalRecordsCount,
    skipped: noMatchRecordsCount,
  };

  return file;
}

export { toFile };
